import React from 'react';

import LogoTitle from '../LogoTitle';
import './middlePartMatchRow.scss';

interface Props {
    sportId: string;
    linkToMatch: string | null;
    marketName?: string;
    homeTitle: string;
    awayTitle: string;
    homeLogo: string;
    awayLogo: string;
    children: JSX.Element;
}

const MiddlePartMatchRow: React.FC<Props> = ({
    linkToMatch,
    marketName,
    homeTitle,
    awayTitle,
    homeLogo,
    awayLogo,
    children,
    sportId,
}) => {
    return (
        <div
            styleName="container"
            className="__app-MiddlePartMatchRow-container"
        >
            <div
                styleName="bunch-left"
                className="__app-MiddlePartMatchRow-bunch"
            >
                {marketName ? (
                    <div
                        styleName="market"
                        className="__app-MiddlePartMatchRow-market"
                    >
                        {marketName}
                    </div>
                ) : (
                    <div />
                )}

                <LogoTitle
                    sportId={sportId}
                    styleName="team"
                    name={homeTitle}
                    logoUrl={homeLogo}
                    linkToMatch={linkToMatch}
                />
            </div>
            <div styleName="middle" className="__app-MiddlePartMatchRow-middle">
                {children}
            </div>
            <div
                styleName="bunch-right"
                className="__app-MiddlePartMatchRow-bunch"
            >
                <LogoTitle
                    sportId={sportId}
                    styleName="team"
                    name={awayTitle}
                    logoUrl={awayLogo}
                    linkToMatch={linkToMatch}
                    isLogoBeforeTeamName={true}
                />
            </div>
        </div>
    );
};

export default MiddlePartMatchRow;
